<div #parentContainer>
  <div
    #contentSlot
    (click)="!disable ? (bottomSheet ? openBottomSheet() : itemsMenuTrigger.openMenu()) : undefined"
  >
    <ng-content></ng-content>
  </div>
  @if (!contentSlot.children.length) {
    <div
      class="min-h-[40px] flex items-center px-base py-sm border border-ui-separator rounded-sm {{
        extraClass
      }}"
      [ngClass]="{
        'w-max': !bottomSheet,
        'cursor-pointer': !disable,
        '!w-full': fullWidth
      }"
      (click)="!disable ? (bottomSheet ? openBottomSheet() : itemsMenuTrigger.openMenu()) : undefined"
    >
      <div class="flex-1 text-txt text-base leading-base">{{ selectedItemLabel ?? placeHolder }}</div>
      @if (!disable) {
        <div class="ml-sm flex text-txt-secondary">
          <svg-icon key="arrow-down-simple" class="!text-xs"></svg-icon>
        </div>
      }
    </div>
  }
  <div [matMenuTriggerFor]="itemsMenu" #itemsMenuTrigger="matMenuTrigger"></div>
</div>

<mat-menu
  #itemsMenu="matMenu"
  [hasBackdrop]="true"
  class="lla-filter-menu"
  (menuOpened)="onMenuOpened()"
>
  <div
    class="p-xs flex flex-col overflow-auto w-full min-w-max"
    [style.width.px]="menuWidth"
    (click)="$event.stopPropagation()"
  >
    @for (item of items; track item) {
      <div
        class="p-xs cursor-pointer hover:bg-ui-hover text-txt text-base leading-base"
        [ngClass]="{ '!bg-ui-hover-1': item.value === selectedItem }"
        (click)="selectedItemChanged.emit(item.value); itemsMenuTrigger.closeMenu()"
      >
        {{ item.label }}
      </div>
    }
  </div>
</mat-menu>
